import { render, staticRenderFns } from "./position-detail.vue?vue&type=template&id=7fbc9d60&scoped=true";
import script from "./position-detail.vue?vue&type=script&lang=jsx";
export * from "./position-detail.vue?vue&type=script&lang=jsx";
import style0 from "./position-detail.vue?vue&type=style&index=0&id=7fbc9d60&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "7fbc9d60", null);
export default component.exports;